import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ANALYTICS_CHANNEL = 'peopleTeams';
var runItLater = function runItLater(cb) {
  if (window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(cb);
  }
  if (typeof window.requestAnimationFrame === 'function') {
    return window.requestAnimationFrame(cb);
  }
  return function () {
    return setTimeout(cb);
  };
};
var fireEvent = function fireEvent(kind) {
  return function (createAnalyticsEvent, body) {
    if (!createAnalyticsEvent) {
      return;
    }
    runItLater(function () {
      createAnalyticsEvent(_objectSpread({
        eventType: kind
      }, body)).fire(ANALYTICS_CHANNEL);
    });
  };
};
export var fireOperationalEvent = fireEvent('operational');
export var fireScreenEvent = fireEvent('screen');
export var fireTrackEvent = fireEvent('track');
export var fireUIEvent = fireEvent('ui');
export var isSeriousError = function isSeriousError(error) {
  if (!error) {
    return false;
  }

  // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
  if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) {
    return false;
  }
  if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) {
    return false;
  }
  if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) {
    return false;
  }
  if (error.message === 'Failed to fetch') {
    return false;
  }
  return true;
};